// import React from "react";
// import {
//   Container,
//   Row,
//   Col,
//   Form,
//   Button,
  
// } from "react-bootstrap";

// export default function AEO() {
// //    const [open, setOpen] = useState(0);
  

//   return (
//     <>
//     <div className="bg-light py-5">
    
//            <section className="bg-light">
//                   <Container>
//                     <Row className="g-4 align-items-start">
//                       {/* LEFT CONTENT */}
//                       <Col lg={8}>
//                               <div>
//                                   <h1>Authorized Economic Operator Scheme from Customs (AEO certification).</h1>
                                  
//                                   <h2>BACKGROUND:</h2>
//                                   <p>AEO is a programme that secures and facilitates global trade under the auspices of the World Customs Organization's (WCO) SAFE Framework of Standards. The program's goal is to improve international supply chain security and make it easier for genuine commodities to flow. AEO comprises a number of actors in the global supply chain. As a result of this programme,</p>
//                                   <p>Customs grants AEO designation and various privileges to an entity involved in foreign trade that has been approved as complying with supply chain security norms. India's AEO Program is in line with the WTO TFA's Article 7.7 commitments.</p>
//                                   <p>AEO is a self-regulatory initiative.It allows Indian Customs to improve and streamline cargo security by working closely with the key players in the international supply chain, including importers, exporters, logistics providers, custodians or terminal operators, custom brokers, and warehouse owners.</p>
                                  
//                               </div>
//                         </Col>
//                                 <Col lg={4}>
//                                              <div className="p-4 shadow rounded right-form">
//                                                <Form>
//                                                  <Form.Control className="mb-3" placeholder="Name" />
//                                                  <Form.Control className="mb-3" placeholder="Email" />
//                                                  <Form.Control className="mb-3" placeholder="Phone" />
//                                                  <Form.Control className="mb-3" placeholder="Subject" />
//                                                  <Button className="w-100">Get Started</Button>
//                                                </Form>
//                                              </div>
//                                </Col>
//             </Row>
//                       <Row className="g-4 align-items-start">
//                           <Col lg={12} xl={12}>
//                           <div>
//                               <h2>Importers and exporters can participate in a three-tier AEO programme (AEO-T1, AEO-T2, and AEO-T3)</h2>
//                                 <p>The old ACP ("Accredited Client Program") and AEO programmes have been decided to be integrated into one new AEO programme. The new programme only offers one tier of certification (AEO-LO) to economic operators other than importers and exporters, whereas there will be three tiers of certification for importers and exporters (i.e. AEO-T1, AEO-T2 and AEO-T3).</p>

//                               <h2>Criteria for AEO-Eligibility for an Entity</h2>
//                               <p>Regardless of the size of the company, anyone involved in the worldwide supply chain that engages in Customs-related activities in India can apply for AEO designation. Exporters, importers, logistic providers (e.g., carriers, airlines, freight forwarders, etc. ), Custodians or Terminal Operators, Customs House Agents, and Warehouse Owners are all possible candidates. This isn't an exhaustive list.</p>
//                                 <p>Businesses that aren't involved in customs-related work or activities aren't eligible to apply. This means that banks, insurance companies, consultants, and other organisations in similar categories will not be eligible for AEO designation.</p>
//                                 <p>The application for AEO status will only apply to the applicant's legal entity; it will not automatically apply to a group of enterprises.</p>
//                                 <p>To apply for AEO status, the applicant must be a resident of India. The applicant must show documentation for this, which may include:</p>
//                                 <p>1. A certificate of registration from the Registrar of Companies.</p>
//                                 <p>2. Details of the places/locations where items are handled in the course of supply to/from an international supply chain, such as loading, unloading, storage, and so on.</p>
//                                 <p>3. Evidence that the company has its own books.</p>
//                                 <p>The applicant must have been in business for at least three years prior to the application deadline. However, in extreme circumstances, the AEO Program Manager may consider certification of a newly constituted corporate entity based on physical verification of internal controls.</p>
//                                 <p>The AEO programme is open to all importers and exporters with a minimum of 25 import or export declarations, i.e. either Bills of Entry or Shipping Bills, during the previous fiscal year.</p>

//                               <h2>Who should opt to apply for AEO?</h2>
//                               <p>Regardless of the size of your company, anyone active in the international supply chain (those involved simply in intra EU supplies are excluded) who conducts customs related activities in the EU can apply for AEO accreditation. This contains the following items:</p>
//                               <ul>
//                                   <li>Importers: They are individuals or businesses who import products and are named as the importer of record once the import declaration is accepted.</li>
//                                   <li>Exporters: They are individuals or businesses who are the owners of the products or have a similar right of disposition over them at the moment the declaration is accepted and on whose behalf the export declaration is made.</li>
//                                   <li>Warehousekeepers: A person or business authorised to run a Customs Warehouse</li>
//                                   <li>Manufacturers: A person or company that ensures that their products are manufactured in a safe and secure manner and that their products are delivered to their customers in a secure manner.</li>
//                                   <li>Forwarders of goods: Organizing goods transportation on behalf of the aforementioned Customs agents and a direct or indirect representative operating on behalf of the aforementioned</li>
//                                   <li>Carriers: A person or company that transports things or is in charge of or responsible for the mode of transport's functioning.</li>
//                               </ul>
                              
//                               <h2>BENEFITS:</h2>
//                               <p>The following are some of the major advantages of the AEO certification:</p>
//                               <ul>
//                                 <li>n circumstances where SION is not announced, AEO Exporters might self-declare SION under paragraph 4.07A of FTP 2015-20.</li>
//                                 <li>Direct Port Inclusion Import deliveries to enable manufacturers' just-in-time inventory management – clearance from quay to warehouse for AEO T1, T2, and T3.</li>
//                                 <li>Direct Port Entry for factory-stuffed containers intended for export by AEOs for AEO T1, T2, AND T3.</li>
//                                 <li>Deferred payment of duties -separating duty payment and customs clearance for AEO T2 and T3</li>
//                                 <li>Benefits of AEO T2 and AEO T3 Mutual Recognition Agreements with other Customs Administrations</li>
//                                 <li>Adjudications and refunds, including IGST refunds and drawback disbursement, are tracked quickly.</li>
//                               </ul>

//                               <h2>Validity</h2>
//                               <p>AEO certificates have a three-year validity for AEO-T1 and AEO-T2, and a five-year validity for AEO-T3 and AEO-LO.</p>

// </div>

//                               </Col>
//                           </Row>
//             </Container>
//         </section>
        
//     </div>
//     </>
//   );
// }

import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaCheckCircle,
  FaFileAlt,
  FaGlobe,
  FaList,
  FaRocket,
  FaIndustry,
  FaHandsHelping,
  FaShieldAlt
} from "react-icons/fa";

export default function AEO() {
  return (
    <div className="bg-light py-5">
      <section className="bg-light">
        <Container>

          {/* TOP */}
          <Row className="g-4 align-items-start mb-4">
            <Col lg={8}>
              <h1>
                Authorized Economic Operator (AEO) Certification
              </h1>

              <p>
                AEO Certification is a globally recognized program that enables
                trusted businesses to benefit from faster customs clearance,
                reduced inspections, and priority treatment.
              </p>

              <p>
                It transforms compliance into a competitive advantage by
                improving supply chain efficiency and global credibility.
              </p>
            </Col>

            <Col lg={4}>
              {/* Add your right-side form */}
            </Col>
          </Row>

          {/* WHAT IS */}
          <h2 className="section-title">
            <FaFileAlt className="icon" /> What is AEO?
          </h2>

          <p>
            AEO (Authorized Economic Operator) is a certification granted by
            Indian Customs to businesses that meet high standards of compliance,
            security, and operational efficiency in international trade.
          </p>

          {/* LEVELS */}
          <h2 className="section-title">
            <FaList className="icon" /> AEO Certification Levels
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> AEO-T1 – Basic certification</li>
            <li><FaCheckCircle /> AEO-T2 – Reduced inspections & priority clearance</li>
            <li><FaCheckCircle /> AEO-T3 – Highest level with maximum benefits</li>
            <li><FaCheckCircle /> AEO-LO – For logistics operators</li>
          </ul>

          {/* ELIGIBILITY */}
          <h2 className="section-title">
            <FaGlobe className="icon" /> Who Can Apply
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Importers & exporters</li>
            <li><FaCheckCircle /> Manufacturers</li>
            <li><FaCheckCircle /> Logistics providers & freight forwarders</li>
            <li><FaCheckCircle /> Customs brokers</li>
            <li><FaCheckCircle /> Warehouse operators & transporters</li>
          </ul>

          {/* CRITERIA */}
          <h2 className="section-title">
            <FaShieldAlt className="icon" /> Eligibility Criteria
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Active involvement in international trade</li>
            <li><FaCheckCircle /> Strong compliance record</li>
            <li><FaCheckCircle /> Robust internal controls</li>
            <li><FaCheckCircle /> Secure supply chain practices</li>
            <li><FaCheckCircle /> Minimum operational history (typically 3 years)</li>
          </ul>

          {/* BENEFITS */}
          <h2 className="section-title">
            <FaRocket className="icon" /> Key Benefits
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Faster customs clearance</li>
            <li><FaCheckCircle /> Reduced inspections</li>
            <li><FaCheckCircle /> Deferred duty payment (for higher tiers)</li>
            <li><FaCheckCircle /> Direct port delivery / entry</li>
            <li><FaCheckCircle /> Global recognition</li>
            <li><FaCheckCircle /> Improved business credibility</li>
          </ul>

          {/* VALIDITY */}
          <h2 className="section-title">
            <FaFileAlt className="icon" /> Validity
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> AEO-T1 & T2 – 3 years</li>
            <li><FaCheckCircle /> AEO-T3 & AEO-LO – 5 years</li>
          </ul>

          {/* PROCESS */}
          <h2 className="section-title">
            <FaIndustry className="icon" /> Application Process
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Eligibility assessment</li>
            <li><FaCheckCircle /> Documentation & SOP preparation</li>
            <li><FaCheckCircle /> Application filing</li>
            <li><FaCheckCircle /> Customs audit & verification</li>
            <li><FaCheckCircle /> Certification approval</li>
          </ul>

          {/* HELP */}
          <h2 className="section-title">
            <FaHandsHelping className="icon" /> How We Help You
          </h2>

          <p>
            At Apex Consultants, we provide complete AEO certification support
            including compliance assessment, documentation, audit preparation,
            and coordination with customs authorities to ensure smooth approval.
          </p>

        </Container>
      </section>
    </div>
  );
}